var _defs, _rect, _rect2, _path, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransportSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.8 11.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0071bc;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .st2, .st3 {\n        fill: #333;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 7.8,
    height: 11.04,
    rx: 1.02,
    ry: 1.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.64,
    y: 1.42,
    width: 6.51,
    height: 6.51,
    rx: 0.72,
    ry: 0.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.28,3.15h3.25c.38,0,.69.31.69.69v1.41H1.59v-1.41c0-.38.31-.69.69-.69Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 2.46,
    cy: 5.46,
    r: 0.54
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5.34,
    cy: 5.46,
    r: 0.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 1.87,
    y: 3.52,
    width: 0.75,
    height: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 2.97,
    y: 3.52,
    width: 0.75,
    height: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 4.07,
    y: 3.52,
    width: 0.75,
    height: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 5.17,
    y: 3.52,
    width: 0.75,
    height: 0.68
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportSign);
export default __webpack_public_path__ + "static/media/transport-sign.01d91cc002899d7ebe8517e9c7073a15.svg";
export { ForwardRef as ReactComponent };